import { getPrimaryTaxonomy } from "~/lib/shared/getPrimaryTaxonomy";
import { getKickerHref } from "~/lib/shared/getKickerHref";
import { heDecodeOrDefault } from "~/lib/shared/html-utils";
import { Article } from "~/types/asgard/Article";
import { ArticleHeaderProps } from "./ArticleHeader";

export type ArticleHeaderApiData = {
  categories: Article["categories"];
  title: Article["title"];
  acf: Pick<Article["acf"], "subhead" | "chart_description">;
};

export const apiToArticleHeaderProps = ({
  categories,
  title,
  acf,
}: ArticleHeaderApiData): ArticleHeaderProps => ({
  kicker: heDecodeOrDefault(getPrimaryTaxonomy(categories)?.name),
  kickerSecondaryText: null,
  kickerHref: getKickerHref(getPrimaryTaxonomy(categories)?.slug),
  headline: heDecodeOrDefault(title.rendered),
  subhead: heDecodeOrDefault(acf.subhead),
  chartDescription: heDecodeOrDefault(acf.chart_description),
});
